import { useCallback, useRef } from 'react'

const useDebounce = (callback: (value: string) => void, delay: number) => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  return useCallback(
    (value: string) => {
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        callback(value)
      }, delay)
    },
    [callback, delay],
  )
}

export default useDebounce
